export const getUploadAttachmentsEndpoint = (appointmentId: string) => `/api/appointments/${appointmentId}/attachments/upload`;